import { env, region } from '@fhs-legacy/frontend/src/utils/environment';

export const sanityProjectId = 'czqk28jt';
export const sanityStage = process.env.REACT_APP_RBI_ENV ?? 'dev';
export const sanityRegion = process.env.REACT_APP_RBI_COUNTRY ?? 'us';

// We can't access process.env in the client, so we need to use the environment variables from the app.config.ts file
// Note: we can only access process.env in case there's EXPO_PUBLIC_ prefix in the environment variable name.
function getSanityDataset(): string {
  try {
    const currentEnv = String(env()).toLowerCase();
    const currentRegion = String(region()).toLowerCase();
    return `${currentEnv}_fhs_${currentRegion}`;
  } catch {
    // Fallback to env var or default
    return `${sanityStage}_fhs_${sanityRegion}`;
  }
}

export const sanityDataset = getSanityDataset();
